import React, { useState } from 'react';
import { FaRegUser } from "react-icons/fa6";
import { appText } from '../../texts';
import axios from 'axios';
import { API_URLS } from './../../urls';
import { IoReturnDownBackOutline } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';
export default function OtpLoginComponent() {
    const [phoneNumber, setPhoneNumber] = useState('');
    const isButtonDisabled = !/^09\d{9}$/.test(phoneNumber);
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1);
    };

    const handlePhoneNumberChange = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        if (value.length <= 11) {
            setPhoneNumber(value);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        localStorage.setItem("otpRequested", "true");

        if (isButtonDisabled) return;

        if (!/^09\d{9}$/.test(phoneNumber)) {
            setErrorMessage("فرمت شماره موبایل نادرست است.");
            setTimeout(() => setErrorMessage(''), 5000);
            return;
        }

        setIsLoading(true);
        setErrorMessage('');

        try {
            const response = await axios.post(`${API_URLS.BASE_URL}auth/login_verification_code`, {
                phone_number: phoneNumber,
            });
            setIsLoading(false);
            localStorage.setItem("phone_number", phoneNumber);
            navigate('/otp?origin=login');


        } catch (error) {
            setIsLoading(false);
            if (error.response) {
                setErrorMessage("مشکلی در ارسال کد یکبار مصرف رخ داده است.");
            } else {
                setErrorMessage("مشکلی در ارتباط با سرور پیش آمده است.");
            }
            setTimeout(() => setErrorMessage(''), 5000);
        }
    };

    return (
        <div className="flex bg-[#F3F5F6] w-full flex-col-reverse md:flex-row">

            <div className="flex flex-col w-full justify-center items-center">

                <div className="w-[100%] flex flex-col items-center justify-center text-center rounded-lg py-6">
                    <p className='text-[#055187] text-[14px]'>برای دریافت کد یکبار مصرف، شماره همراه خود را وارد کنید.</p>
                    <div className="w-full flex items-center justify-center text-center my-2">
                        <div className="relative w-[85%]">
                            <FaRegUser className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
                            <input
                                className="w-full bg-white py-3 border border-solid rounded-[40px] pl-10 pr-9"
                                type="text"
                                placeholder="09123456789"
                                value={phoneNumber}
                                onChange={handlePhoneNumberChange}
                                onKeyDown={(e) => e.key === "Enter" && handleSubmit(e)}
                            />
                        </div>
                    </div>


                    {errorMessage && <p className="flex items-center py-2 pr-3 mt-1 w-[85%] border border-solid border-red-700 rounded-lg text-[#ff1942] bg-[#ffedf1]">{errorMessage}</p>}

                    <div className="w-[85%] flex flex-col justify-center mt-4">
                        <button
                            type="submit"
                            disabled={isButtonDisabled || isLoading}
                            onClick={handleSubmit}
                            onKeyDown={(e) => e.key === "Enter" && handleSubmit(e)}
                            className={`w-full ${isButtonDisabled && !isLoading
                                ? "bg-gray-400 cursor-not-allowed"
                                : "bg-[#02bfe7]"
                                } text-white rounded-[40px] border-none py-3 mt-1 flex items-center justify-center ${isLoading ? "cursor-not-allowed" : "cursor-pointer"
                                }`}
                        >
                            {isLoading ? (
                                <div className="w-full h-5 animate-bounce">درخواست کد یکبار مصرف</div>
                            ) : (
                                <p>درخواست کد یکبار مصرف</p>
                            )}
                        </button>
                    </div>
                </div>
            </div>

        </div>

    )
}
